import {ReactECharts} from '../../../../components/charts/ReactECharts'
import {barChartOption} from './barChartOption'
import React from 'react'
import {ChartOptions, ChartResults} from '../../../../actions/queryBuilderApi'
import {useChartDataFetcher} from './chartDataFetcher'
import { Spin } from "antd"

export type BarChartProps = {
    chartOptions: ChartOptions
    defaultChartOptions?: ChartOptions
    defaultResults?: ChartResults
}

export const BarChart = ({chartOptions, defaultChartOptions, defaultResults}: BarChartProps) => {

    const fetchedChartResults = useChartDataFetcher(!defaultResults ? chartOptions : undefined)
    const rawResults = defaultResults ?? fetchedChartResults

    if (!rawResults) {
        return <Spin />
    }

    const activeOptions = defaultChartOptions ?? chartOptions
    const processedChartResults = processChartResults(activeOptions, rawResults)
    const barChartOptions = barChartOption(processedChartResults)

    return <ReactECharts option={barChartOptions} settings={{notMerge: true}}/>

}

export const processChartResults = (chartOptions: ChartOptions, chartResults: ChartResults): ChartResults => {

    if (!chartResults || !chartResults.labels || !chartResults.values?.[0]?.data) {
        return chartResults;
    }

    const rawValues = chartResults.values[0].data;

    let items = chartResults.labels.map((label, index) => {
        const val = rawValues[index]
        const numericValue = Array.isArray(val) ? val[1] : val
        return {
            label,
            value: Number(numericValue) || 0
        }
    })

    if (chartOptions.sort !== 0) {
        items.sort((a, b) => (a.value - b.value) * chartOptions.sort)
    }

    if (chartOptions.topTen) {
        items = items.slice(0, 10)
    }

    return {
        ...chartResults,
        labels: items.map(item => item.label),
        values: [
            {
                ...chartResults.values[0],
                data: items.map((item, index) => [index, item.value])
            }
        ]
    }
}